import React from "react";
import "./BiodataView.css";
import { useSelector } from 'react-redux';

const linkify = (text) => {
    if (!text) return "";

    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;

    return text.replace(urlRegex, function(url) {
        const href = url.startsWith('http') ? url : `https://${url}`;
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    }).replace(/\n/g, "<br>");
};

const BiodataView = ({ modelObject, formData, ProfileData}) => {
    const candidateProfile = useSelector(state => state.candidateProfile.candidateProfile);
    if (!modelObject || !formData) return null;

    const seenFields = new Set();
    const fieldObjects = modelObject.orderBy.map(orderField => {
        const field = modelObject.fields.find(f => f.fieldName === orderField);
        if (field && !seenFields.has(field.fieldName)) {
            seenFields.add(field.fieldName);
            return field;
        }
        return null;
    }).filter(Boolean);

    const rows = [];

    const aboutField = fieldObjects.find(f => f.fieldName === 'about');
     if (aboutField && (candidateProfile || (formData[aboutField.fieldName] && formData[aboutField.fieldName] !== ""))) {
            const aboutHTML = linkify(formData[aboutField.fieldName]);
        rows.push(
            <div className="biodata-row" key="about">
                <div className="biodata-itemOne about-item">
                <div className="about-label-colon">
                    <span className="label">{aboutField.label}</span>
                     <span className="colon">:</span>
                </div>
              <div className="about-text" dangerouslySetInnerHTML={{ __html: aboutHTML }} />
                </div>
            </div>
        );
    }

const nameField = fieldObjects.find(f => f.fieldName === 'name');
if (nameField) {
    rows.push(
        <div className="biodata-row" key="name-gender">
            <div className="biodata-item">
                <span className="label">{nameField.label}</span>
                 <span className="colon">:</span>
                <span className="value">{formatValue(nameField, formData[nameField.fieldName])}</span>
            </div>
            {ProfileData?.gender && modelObject.orderBy.includes('name') && (
                <div className="biodata-item">
                    <span className="label">Gender</span>
                     <span className="colon">:</span>
                    <span className="value">{ProfileData.gender}</span>
                </div>
            )}
        </div>
    );
}


    const filteredFields = fieldObjects.filter(f => {
    if (f.fieldName === 'about' || f.fieldName === 'name') return false;

    if (!candidateProfile && (!formData[f.fieldName] || formData[f.fieldName] === "")) {
        return false;
    }

    return true;
});


    for (let i = 0; i < filteredFields.length; i += 2) {
        const left = filteredFields[i];
        const right = filteredFields[i + 1];

        rows.push(
            <div className="biodata-row" key={`row-${i}`}>
                <div className="biodata-item">
                    <span className="label">{left.label}</span>
                    <span className="colon">:</span>
                    <span className="value">{formatValue(left, formData[left.fieldName])}</span>
                </div>
                {right && (
                    <div className="biodata-item">
                        <span className="label">{right.label}</span>
                        <span className="colon">:</span>
                        <span className="value">{formatValue(right, formData[right.fieldName])}</span>
                    </div>
                )}
            </div>
        );
    }

    return <div className="biodata-container">{rows}</div>;
};


const formatValue = (field, value) => {
    if (value === null || value === undefined || value === "") return;

    if (Array.isArray(value)) {
         if (value.length > 0 && typeof value[0] === 'object' && value[0].label) {
            return value.map(v => v.label).join(", ");
        }
        return value.join(", ");
    }
    if (typeof value === "boolean") return value ? "Yes" : "No";
    if (typeof value === "object" && value.label) {
        return value.label;
    }
    return value;
};


export default BiodataView;
